var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.479c-8.05 0-14.583 6.533-14.583 14.583S9.95 32.646 18 32.646s14.584-6.534 14.584-14.584S26.05 3.48 18 3.48Zm0 16.042a1.463 1.463 0 0 1-1.458-1.459V12.23c0-.802.656-1.458 1.458-1.458.802 0 1.459.656 1.459 1.458v5.833c0 .802-.657 1.459-1.459 1.459Zm1.459 5.833h-2.917v-2.917h2.917v2.917Z",
    fill: "#C13635"
  })));
};
export default SvgError;